<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import { required } from "vuelidate/lib/validators";
// import Vuetable from 'vuetable-2'
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import Vue from "vue";
import axios from "axios";
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import moment from "moment";
import 'boxicons/css/boxicons.min.css';
import 'boxicons';
// import DatePicker from "vue2-datepicker";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";
Vue.component('v-select', vSelect)

// register the plugin on vue
import Toasted from 'vue-toasted';

Vue.use(Toasted);
// Lets Register a Global Error Notification Toast.

/**
 * Departamento component
 */
export default {
  page: {
    title: "Asignacion Lote Animal",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {Layout, PageHeader,Loader,
    // Vuetable,
    VuetablePagination},
  data() {
    return {
      page_a :   this.$route.params.page_a,
      lote_a :   this.$route.params.lote_a,
      formLote : {
        tipo_lote: "",
      },	
      formActivo : {
        estado: "Activo",
        value: true
      },	
      arrTipoLote :[
        { nombre: 'Reemplazo' },
        { nombre: 'Gestacion' },
        { nombre: 'Lactancia' },
        { nombre: 'Destete' },
        { nombre: 'Cerdo De Engorde' },
        { nombre: 'Descarte' },
      ],
      arrayEstado :[
        { nombre: 'Activo', value:true },
        { nombre: 'Inactivo', value: false }
      ],
      userT : this.$store.state.authfack.user,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token}
      },
      metododeBusqueda:false,
      fecha_inicio: "",
      rangode_fecha:"",
      fecha_fin:"",
      repit : true,
      fields: [
        {
          name: "no_lote",
          title: "No. Lote",
          sortField: "no_lote",
          width: "20%",
        },
        {
          name: "no_animales",
          title: "No. Animales",
          sortField: "no_animales",
          width: "20%",
        },
        {
          name: "fecha_inicio",
          title: "No. Lote",
          sortField: "fecha_inicio",
          width: "20%",
        },
        {
          name: "tipo_lote",
          title: "Tipo Lote",
          sortField: "tipo_lote",
          width: "20%",
        },
        {
          name: "estado",
          title: "Estado",
          titleClass: "",
          dataClass: "text-muted",
          width: "10%",
        },
        {
          name: "actions",
          title: "Acciones",
          titleClass: "",
          width: "10%",
        },
      ],
      apiUrl: process.env.VUE_APP_URL,
      // apiBase: process.env.VUE_APP_URL +"compras/get?tienda=" + this.$store.state.authfack.user.tienda,
      apiBase: process.env.VUE_APP_URL +"lotes/get" ,
       css: {
      table: {
        tableClass: 'table table-striped table-bordered table-hovered',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
      },
      pagination: {
        infoClass: 'pull-left',
        wrapperClass: 'vuetable-pagination pull-right',
        activeClass: 'btn-primary',
        disabledClass: 'disabled',
        pageClass: 'btn btn-border',
        linkClass: 'btn btn-border',
        icons: {
          first: '',
          prev: '',
          next: '',
          last: '',
        },
      }
    },
      formDepa: {
        nombre: "",
        id: 0,
      },
      arrayLotes:[],
      tiendasData:[],
      updating: false,
      estadotabla:true,
      title:"Asignacion Lote Animal",
      itemst: [
        {
          text: "Asignacion Lote Animal",
          href: "/",
        },
        {
          text: "Lista de Compras de Concentrado",
          active: true,
        },
      ],
   
       searchType: [
        { nombre: "No. Corral", value: "no_corral" },
      ],
      options : {
          theme: "outline",  
          position: "top-right", 
          duration : 5000,
          keepOnHover:true,
          action : {
            text : 'X',
            onClick : (e, toastObject) => {
                toastObject.goAway(0);
          },
         
    },
      },
       loadingtable:false,
       sortBy: "no_corral",
       sortDesc: false,
       searchLabel: { nombre: "No. Corral", value: "no_corral" },
       filterLabel: { nombre: "No. Corral", value: "no_corral" },
       showModalL: false, //Loading
       showModalD: false, //Desactivar
       showModalA: false, //Activar
       data:[],
       pageOptions: [4, 10, 15, 20],
       search: "",
        page:  1,

        perPage: 20,
        from: 0,
        to: 0,
        total: 0,
        lastPage: 0,
        ArrayLotes: [],
        curret:0,
    };
  },
  validations: {
    formDepa: {
      nombre: { required},
    },
  },
  async mounted() {

    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
        this.getLotes(this.page, this.search);
    }
   
  },
   watch: {
  
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    formatoPresentacion(date) {
      return moment(date).locale("es").format("LL");
    // return moment(date).locale("es").format("LLLL");
    },

    async getLotes(page, search){

        try {
          // const url =this.apiBase;
          // console.log();
        const valor = this.formActivo.estado.value ?? true;
        const response = await axios.get(this.apiBase+'?tipo_lote='+this.formLote.tipo_lote.nombre + '&estado='+valor+'&lote_animal='+true , {
          params: {
            page:page,
            limite: this.perPage,
            search: search
          },
          headers: { "x-token": this.userT.token}
        });
        this.ArrayLotes = response.data.data;
        // console.log(response);
        this.onPaginationData(response.data);
        // this.totalItems = response.data.total;
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    },
     customFormatter(date) {
      return moment(date).format('YYYY-MM-DD');
    },
     limpiarfiltro(){
        let me = this;
        me.fecha_inicio = "";
        me.fecha_fin = "";
    },
    separarfechas(){
      this.fecha_inicio=this.rangode_fecha[0]
      this.fecha_fin=this.rangode_fecha[1]
    },
  activarBuscadorFechas(search ,index){
      this.metododeBusqueda = (index == 3) ? true : false;
    },
   // FUNCIONES AUXILIARES
    money(value) {
      return (
        "Q " +
        parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
showDate(date) {
 return moment(date).locale("es").utc().format("MMM Do YYYY");
 },

    //Desactivar registro
  desactivar(){
    const {id } =this.formDepa;
     axios
          .put(process.env.VUE_APP_URL + "compras/desactivate", {
            id: id,
          },{
            headers: { "x-token": this.userT.token}
          })
          .then(() => {
             this.showModalD = false;
             Vue.toasted.error(("Compra Anulada"),this.options);
            //  this.$refs.vuetable.refresh();
          })
          .catch((error) => {
            this.errorMessage = error.message;
            console.error("There was an error!", error);
             Vue.toasted.error("Error para desactivar",this.options);
          });
  },
    //Activar registro
  activate(){
     const {id,nombre  } =this.formDepa;
     axios
          .put(process.env.VUE_APP_URL + "departamentos/activate", {
            id: id,
          },{
            headers: { "x-token": this.userT.token}
          })
          .then(() => {
            this.showModalA = false;
            Vue.toasted.info((nombre+" Activado"),this.options);
            // this.$refs.vuetable.refresh();
          })
          .catch((error) => {
            this.errorMessage = error.message;
            console.error("There was an error!", error);
             Vue.toasted.error("Error para activar",this.options);
          });
  },


   //Buscador dentro de la tabala
    onFiltered(){
        // console.log('aqui')
      this.search = this.search.toLowerCase();
    //   this.$refs.vuetable.refresh();
    },
   //enviar datos a la Paginacion
   onPaginationData(paginationData) {
    // console.log(paginationData)
      this.to = paginationData.to;
      this.total = paginationData.total;
      this.lastPage = paginationData.last_page;
      this.items = paginationData.data;
    //   this.arrayLotes = this.items;
    // console.log(paginationData.to)
      this.$refs.pagination.setPaginationData(paginationData);
    },
    //Cambiar tamaño de filas en la tabala para mostrar
    changePageSize() {
        // console.log('aqui')
    //   this.$refs.vuetable.refresh();
        this.getLotes(this.page, this.search);
    },
   async changeTypeDates(){
    // console.log('aqui')
    //   await this.separarfechas()
      // console.log(this.fecha_inicio, this.fecha_fin);
    //   this.$refs.vuetable.refresh();
    this.getLotes(this.page, this.search);
    },
    // Cambiar el valor del dropwdown para poder filtrar
    changeTypeSearch(type) {
        // console.log(type)
      this.fecha_inicio = (type.value == "fecha") ? '' : ''
      this.fecha_fin = (type.value == "fecha") ? '' : '';
      this.searchLabel = type;
    //   this.$refs.vuetable.refresh();
    },
    //Cuando cambia de pagina
    onChangePage(page) {
        // console.log(page)
        this.curret = page;
        this.getLotes(page, this.search);
    //   this.$refs.vuetable.changePage(page);

    },
     //Query para realizar busquedas y ordenar
    makeQueryParams(sortOrder, currentPage) {
        // console.log(sortOrder, currentPage)
      console.log(this.formActivo.estado);
      return sortOrder[0]
        ? {
            fecha_inicio: this.fecha_inicio,
            fecha_fin: this.fecha_fin,
            criterio: sortOrder[0] ? sortOrder[0].sortField : this.searchLabel.value,
            categoria: this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
            tipo_lote : this.formLote.tipo_lote.nombre,
            estado : this.formActivo.estado
          }
        : {
            fecha_inicio: this.fecha_inicio,
            fecha_fin: this.fecha_fin,
            criterio: sortOrder[0] ? sortOrder[0].sortField : this.searchLabel.value,
            categoria: this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
            tipo_lote : this.formLote.tipo_lote.nombre,
            estado : this.formActivo.estado
          };
    },
  //AL ABRIR EL MODAL RESETEAR LAS VALIDACIONES Y VARIABLES
 openModal(model) {
      switch (model) {
        case "save": {
       this.$v.$reset();
      this.limpiarVariables();
         
      // console.log("entrando a resetear")
          break;
        }
        case "update": {
       this.$v.$reset();
          break;
        }
      }
    },
    //Variables que necesitan ser limpiadas para los modales
limpiarVariables(){
   this.formDepa.id=0;
   this.formDepa.nombre="";
},
 //Cuanso se cierre el modal por cualquier motivo, cerrar los modadles y en actualizar parar loading
 closeModal(model) {
      switch (model) {
        case "save": {
         this.showModalN=false;
          this.showmodalL = false;
          break;
        }
         case "update": {
           this.showModalE=false;
          this.showmodalL = false;
          break;
        }
      }
    },

    //Para abrir los modales y pasar los datos de la fila o limpiar valores
    onActionClicked(action, data) {
  
      
     if(action=="desactivate-item"){
        this.formDepa.nombre=data.no_factura_c;
        this.formDepa.id=data.id;
        this.showModalD = true
      }
    
    },
    viewLoteAnimal(id){
        // console.log(this.curret)  
        this.$router.push({ name: 'vista_lote', params: { id: id, page:this.curret, lote: this.formLote.tipo_lote.nombre } });
    },
    loteStyle(tipo_lote){
      
      return {
      backgroundColor: tipo_lote === 'Engorde' ? '#FF7F50' : // Azul para el tipo A
                       tipo_lote === 'Gestacion' ? '#48D1CC' :
                       tipo_lote === 'Lactancia' ? '#4CAF50  ': // Verde para el tipo B
                       '#4682B4', // Naranja para otros tipos
      color: '#fff', // Texto en blanco
      padding: '20px' // Padding fijo
    };

    
  
    },
    loteClass(tipo_lote) {
        switch(tipo_lote) {
            case 1: return 'lote-coral';
            case 2: return 'lote-aqua';
            case 3: return 'lote-gold';
            case 4: return 'lote-steel';
            default: return 'lote-coral';
        }
    },
    
  },
   computed: {
    ...authComputed,
    ...mapState("authfack", ["status"])
    /**
     * Total no. of records
     */
  
    }
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="itemst" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="col-12 text-center mb-4">
              <h1 class="list-title">Listado de Lotes</h1>
            </div>
            <div class="row mt-4">
              <div class="container-fluid">
                <div class="header-container mb-4">
                  <div class="row align-items-center">
                    <div class="col-sm-12 col-md-3">
                      <div id="tickets-table_length" class="dataTables_length">
                        <label class="d-inline-flex align-items-center w-100">
                          Mostrar&nbsp;
                          <b-form-select
                            class="form-select form-select-lg elegant-select"
                            v-model="perPage"
                            @input="changePageSize(); getLotes(page, search);"
                            size="lg"
                            :options="pageOptions"
                          ></b-form-select>
                        </label>
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-4">
                      <div id="tickets-table_length" class="dataTables_length text-md-end">
                        <label class="d-inline-flex align-items-center w-100">
                          <b-dropdown
                            v-if="searchType"
                            id="ddown1"
                            size="lg"
                            class="elegant-dropdown w-100"
                          >
                            <template v-slot:button-content>
                              {{'Ordenar por: '+ searchLabel.nombre}}
                              <i class="mdi mdi-chevron-down"></i>
                            </template>
                            <b-dropdown-item
                              v-for="(search, index) in searchType"
                              :key="index"
                              @click="changeTypeSearch(search); getLotes(page, search); activarBuscadorFechas(search, index); limpiarfiltro();"
                            >
                              {{ search.nombre }}
                            </b-dropdown-item>
                          </b-dropdown>
                        </label>
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-5 text-md-start">
                      <div id="tickets-table_length" class="dataTables_length">
                        <label class="d-inline-flex align-items-center w-100">
                          <b-form-input
                            v-model="search"
                            type="search"
                            @input="onFiltered(); getLotes(page, search)"
                            placeholder="Buscar..."
                            class="form-control form-control-lg elegant-input"
                          ></b-form-input>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="button-select-container text-center mb-4">
                  <router-link :to="{ name: 'new_asignacion_corrales_l' }">
                    <button
                      v-b-modal.modalSave
                      type="button"
                      class="btn elegant-button mb-2 me-2 btn-cerdos-engorde"
                      @click="onActionClicked('new-item')"
                    >
                      <i class="mdi mdi-plus me-1"></i> Cerdos Engorde / Destete
                    </button>
                  </router-link>
                  <router-link :to="{ name: 'new_asignacion_corrales' }">
                    <button
                      v-b-modal.modalSave
                      type="button"
                      class="btn elegant-button mb-2 me-2 btn-nueva-asignacion"
                      @click="onActionClicked('new-item')"
                    >
                      <i class="mdi mdi-plus me-1"></i> Nueva Asignación
                    </button>
                  </router-link>
                  <v-select
                      v-model.trim="formLote.tipo_lote"
                      :state="!formLote.tipo_lote"
                      :options="arrTipoLote"
                      @input="getLotes(page, search)"
                      label="nombre"
                      class="elegant-select"
                  ></v-select>
                  <v-select
                      v-model.trim="formActivo.estado"
                      :state="!formActivo.estado"
                      :options="arrayEstado"
                      @input="getLotes(page, search)"
                      label="nombre"
                      class="elegant-select"
                  ></v-select>
                </div>

                <Loader :loading="loadingtable">
                  <div class="container-fluid">
                    <div class="row">
                      <div v-for="(lote) in ArrayLotes" :key="lote.id" class="col-xl-3 col-lg-4 col-md-6 col-sm-12 mb-5">
                        <div class="card larger-card h-100" :class="loteClass(lote.tipo_lote)" :style="loteStyle(lote.tipo_lote)" @click="viewLoteAnimal(lote.id, page)">
                          <div class="card-body elegant-card p-5 d-flex flex-column justify-content-center align-items-center">
                            <div class="product-name text-center mb-3">
                              Tipo  ({{ lote.tipo_lote }})
                            </div>
                            <div class="product-name text-center mb-3">
                              Corral  ({{ lote.no_lote }})
                            </div>
                            <div class="product-name text-center mb-3">
                              Total Animales  ({{ lote.no_animales }})
                            </div>
                            <div class="elegant-card pigs">
                              <i class="icon fas fa-piggy-bank"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style="padding-top: 20px">
                    <vuetable-pagination
                      ref="pagination"
                      :css="css.pagination"
                      @vuetable-pagination:change-page="onChangePage"
                      class="elegant-pagination"
                    ></vuetable-pagination>
                  </div>
                </Loader>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<style scoped>
body {
  overflow-y: hidden;
}
.container-fluid.no-scroll {
  overflow: hidden;
}
.icon {
  font-size: 1rem;
  margin-bottom: 0.5rem;
}
.list-title {
  font-size: 2.5rem;
  font-weight: bold;
  color: #333;
  text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.header-container {
  background: linear-gradient(135deg, #f0f0f0, #d9d9d9);
  padding: 25px;
  border-radius: 25px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}
.elegant-select {
  border-radius: 12px;
  padding: 10px;
  font-size: 1rem;
}
.elegant-dropdown {
  border-radius: 12px;
  padding: 10px;
  font-size: 1rem;
}
.elegant-input {
  border-radius: 12px;
  padding: 10px;
  font-size: 1rem;
}
.larger-card {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border-radius: 2px;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  background-size: cover;
  background-position: center;
  filter: brightness(1.2);
  border: 5px solid #457b9d;
}
.larger-card:hover {
  transform: scale(1.05);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.3);
}
.elegant-card {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 2px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 0rem;
  text-align: center;
  transition: all 0.3s ease;
}
.product-name {
  background-color: rgba(0, 0, 0, 0.7);
  color: #ffffff;
  padding: 8px;
  border-radius: 10px;
  font-weight: bold;
  font-size: 1rem;
  max-height: 5em;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.elegant-pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
  margin-top: 20px;
  padding: 15px;
  background-color: #f0f0f0;
  border-radius: 15px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.header-options-container {
  background: linear-gradient(135deg, #f0f0f0, #d9d9d9);
  padding: 20px;
  border-radius: 25px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  margin-bottom: 40px;
}
.elegant-select-label,
.elegant-dropdown-label,
.elegant-input-label {
  font-weight: bold;
  font-size: 1.1rem;
  color: #333;
}
.elegant-select,
.elegant-dropdown,
.elegant-input {
  border-radius: 12px;
  padding: 10px;
  font-size: 1rem;
  transition: all 0.3s ease;
}
.elegant-button {
  font-size: 1.2rem;
  padding: 10px 25px;
  border-radius: 20px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: none;
}
.elegant-button:hover {
  transform: scale(1.05);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
}
.btn-cerdos-engorde {
  background-color: #3a86ff;
  color: #fff;
}
.btn-cerdos-engorde:hover {
  background-color: #3578e5;
}
.btn-nueva-asignacion {
  background-color: #06d6a0;
  color: #fff;
}
.btn-nueva-asignacion:hover {
  background-color: #05b88c;
}
@media (max-width: 576px) {
  .product-name {
    font-size: 1.1rem;
  }
}
.v-select {
  width: 100%; /* Asegura que el select tome el ancho completo */
  max-width: 300px; /* Limita el ancho máximo si es necesario */
  border-radius: 12px; /* Bordes redondeados */
  padding: 10px;
  font-size: 1rem;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Añade una sombra para que destaque */
  background-color: #f9f9f9; /* Color de fondo suave */
  border: 1px solid #ddd; /* Borde ligero */
  transition: all 0.3s ease;
}

.v-select:hover, .v-select:focus {
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15); /* Mayor sombra al enfocar */
  border-color: #06d6a0; /* Color de borde al enfocar */
}

.v-select .dropdown-toggle {
  color: #333;
  font-weight: bold;
}

.v-select .dropdown-menu {
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15); /* Sombra para el menú desplegable */
  font-size: 1rem;
}

.v-select .vs__dropdown-toggle {
  background: #06d6a0; /* Color del fondo del botón */
  color: #fff; /* Color del texto */
  border-radius: 12px;
  font-weight: bold;
}

.v-select .vs__dropdown-toggle:hover {
  background: #05b88c; /* Color al hacer hover en el botón */
}

.v-select .vs__search input {
  border: none;
  outline: none;
}

.button-select-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px; /* Espacio entre los botones y el select */
}

.elegant-select {
  width: 250px; /* Aumenta el ancho del select */
  max-width: 100%; /* Evita que crezca demasiado en pantallas pequeñas */
  border-radius: 12px;
  padding: 10px;
  font-size: 1rem;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  transition: all 0.3s ease;
}

.elegant-button {
  font-size: 1rem;
  padding: 8px 20px;
}
body {
  overflow-y: auto;
}
.header-container {
  background: linear-gradient(135deg, #f0f0f0, #d9d9d9);
  padding: 20px;
  border-radius: 15px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Aseguramos que todo sea responsivo */
.header-container .row {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

/* Botones en móviles */
.button-select-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  margin-top: 10px;
}

.button-select-container button {
  font-size: 0.9rem;
  padding: 8px 15px;
}

/* Ajustes para móviles */
@media (max-width: 768px) {
  .header-container {
    padding: 15px;
    border-radius: 10px;
  }

  .header-container .row > div {
    width: 100%;
    margin-bottom: 10px;
  }

  .button-select-container {
    flex-direction: column;
    gap: 15px;
  }

  .elegant-select {
    width: 100%;
    max-width: none;
  }

  .elegant-button {
    font-size: 0.9rem;
    padding: 8px 15px;
  }
}

@media (max-width: 576px) {
  .list-title {
    font-size: 1.5rem;
    text-align: center;
  }

  .button-select-container {
    flex-direction: column;
    gap: 10px;
  }

  .elegant-select {
    font-size: 0.9rem;
    padding: 8px;
  }

  .header-container .row {
    flex-direction: column;
    align-items: center;
  }

  .header-container label {
    width: 100%;
    text-align: center;
  }
}

</style>
